export const GRID_POINTS = Object.freeze({
    xxs: 370,
    xs: 480,
    sm: 680,
    md: 850,
    lg: 950,
    xl: 1100,
    xxl: 1600
});
